import { initDeviceId, getStoredDeviceId } from "@/utils/deviceId";
import axios from "axios";
import { createContext, useContext, useEffect, useState } from "react";

const DeviceContext = createContext({ deviceId: null, ready: false });

let axiosInterceptorId = null;

function applyAxiosInterceptor(deviceId) {
  if (axiosInterceptorId !== null) {
    axios.interceptors.request.eject(axiosInterceptorId);
  }
  axiosInterceptorId = axios.interceptors.request.use((config) => {
    if (deviceId) config.headers["X-DEVICE-ID"] = deviceId;
    return config;
  });
}

export function DeviceProvider({ children }) {
  const [deviceId, setDeviceId] = useState(() => getStoredDeviceId());
  const [ready, setReady] = useState(false);

  useEffect(() => {
    // Pasang interceptor segera dengan device ID tersimpan (fast path)
    const stored = getStoredDeviceId();
    if (stored) {
      applyAxiosInterceptor(stored);
    }

    // Registrasi/konfirmasi ke server — tidak memblokir render
    initDeviceId()
      .then((result) => {
        const id = result?.deviceId || stored;
        if (id) {
          applyAxiosInterceptor(id);
          setDeviceId(id);
        }
      })
      .catch(() => {})
      .finally(() => setReady(true));
  }, []);

  return (
    <DeviceContext.Provider value={{ deviceId, ready }}>
      {children}
    </DeviceContext.Provider>
  );
}

export function useDevice() {
  return useContext(DeviceContext);
}
